import { LegalLayout } from './LegalLayout';

export function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" updatedDate="April 29, 2026">
      <section aria-label="Agreement">
        <p>
          These Terms of Service (“Terms”) govern your use of the Grow With Call
          website. By accessing or using this website, you agree to these Terms.
          If you do not agree, do not use the website.
        </p>
      </section>

      <section aria-label="Website use">
        <h2 className="text-base font-semibold text-slate-900">Website use</h2>
        <p className="mt-3">
          You may use this website for lawful purposes only. You agree not to
          misuse the website, attempt to interfere with its operation, or access
          areas you are not authorized to access.
        </p>
      </section>

      <section aria-label="No professional advice">
        <h2 className="text-base font-semibold text-slate-900">
          No professional advice
        </h2>
        <p className="mt-3">
          Content on this website is provided for general informational purposes
          and does not constitute professional advice. For services, scopes, or
          pricing, please contact us directly.
        </p>
      </section>

      <section aria-label="Inquiries and service discussions">
        <h2 className="text-base font-semibold text-slate-900">
          Inquiries and service discussions
        </h2>
        <p className="mt-3">
          Contacting us through the website or email does not create a client
          relationship or a binding agreement. Any services will be governed by a
          separate written agreement where applicable.
        </p>
      </section>

      <section aria-label="Intellectual property">
        <h2 className="text-base font-semibold text-slate-900">
          Intellectual property
        </h2>
        <p className="mt-3">
          The website and its content (including text, branding, and layout) are
          owned by Grow With Call or its licensors and are protected by
          applicable laws. You may not copy, reproduce, or distribute content
          without permission, except as allowed by law.
        </p>
      </section>

      <section aria-label="Disclaimer">
        <h2 className="text-base font-semibold text-slate-900">Disclaimer</h2>
        <p className="mt-3">
          The website is provided on an “as is” and “as available” basis. We do
          not warrant that the website will be uninterrupted, error-free, or
          secure.
        </p>
      </section>

      <section aria-label="Limitation of liability">
        <h2 className="text-base font-semibold text-slate-900">
          Limitation of liability
        </h2>
        <p className="mt-3">
          To the maximum extent permitted by law, Grow With Call will not be
          liable for any indirect, incidental, special, consequential, or
          punitive damages arising from your use of the website.
        </p>
      </section>

      <section aria-label="Changes">
        <h2 className="text-base font-semibold text-slate-900">Changes</h2>
        <p className="mt-3">
          We may update these Terms from time to time. The “Last updated” date
          above indicates the most recent revision.
        </p>
      </section>

      <section aria-label="Contact">
        <h2 className="text-base font-semibold text-slate-900">Contact</h2>
        <p className="mt-3">
          Questions about these Terms can be sent to{' '}
          <a
            className="font-semibold text-sky-800 hover:text-sky-900"
            href="mailto:founder@growwithcall.com"
          >
            founder@growwithcall.com
          </a>
          .
        </p>
      </section>
    </LegalLayout>
  );
}

